<template>
  <footer class="page-footer center no-print">

    <!--Footer Links-->
    <div class="container-fluid">
      <div class="row m-t-2">
        <div class="col-md-3">
          <address>
            <p>Rua Cerca das Cabanas, lote 3B</p>
            <p>7645-247 Vila Nova de Milfontes</p>
            <p>Telefone: +351 936 326 295</p>
          </address>
        </div>
        <div class="col-md-6">
          <ul class="footerLinks" v-if="typeof $store.state.user.data !== 'undefined'">
            <li v-if="$store.state.user.data.type === 'promoter'"><router-link :to="'/'+language+'/supplier/terms'">{{t('General Terms of Service')}}</router-link></li>
            <li>
              <a v-if="language === 'pt'" :href="apiPublicUrl+'docs/MANGOPAY_TERMS__PI_EN.pdf'" target="_blank">{{t('Framework Contract of the Payment Processing Entity')}}</a>
              <a v-if="language === 'en'" :href="apiPublicUrl+'docs/MANGOPAY_TERMS__PI_EN.pdf'" target="_blank">{{t('Framework Contract of the Payment Processing Entity')}}</a>
            </li>
            <li v-if="typeof $store.state.user.data !== 'undefined'">
              <router-link :to="`/${language}/terms`" v-if="$store.state.user.data.type !== 'promoter'">
                {{t('Terms of Use')}}
              </router-link>
            </li>
            <li v-if="typeof $store.state.user.data !== 'undefined'">
              <router-link :to="`/${language}/privacy-policy`" v-if="$store.state.user.data.type !== 'promoter'">
                {{t('Privacy Policy')}}
              </router-link>
            </li>
          </ul>
          <ul class="footerLinks">
            <li><router-link :to="`/${language}/supplier`">{{t('I want to be a partner')}}</router-link></li>
            <li><router-link :to="`/${language}/faq`">{{t('FAQ')}}</router-link></li>
            <li><a href="https://blog.booknatura.com" target="_blank">Blog</a></li>
            <li><router-link :to="`/${language}/about-us`">{{t('About Us')}}</router-link></li>
          </ul>
          <div>
            <p>Email: <a href="mailto:info@booknatura.com">info@booknatura.com</a></p>
          </div>
        </div>
        <div class="col-md-3 text-xs-right logos">
          <a href="https://www.facebook.com/booknaturapt/" target="_blank"><img src="/static/img/fb.svg" height=16 alt="Facebook Logo"/></a>
          <a href="https://www.instagram.com/booknatura/" target="_blank"><img src="/static/img/instagram.svg" height=16 alt="Facebook Logo"/></a>
          <a href="https://twitter.com/booknatura" target="_blank"><img src="/static/img/twitter.svg" height=16 alt="Twitter Logo"/></a>
        </div>
      </div>
      <div class="support row m-t-3 m-b-4">
        <div class="col-md-6 logoCol">
          <img src="/static/img/barra_cofin_FEDER.svg" />
        </div>
        <div class="col-md-6 logoCol">
          <img src="/static/img/barra_cofin_FSE.svg" />
        </div>
      </div>
    </div>
    <!--/.Footer Links-->

    <!--Copyright-->
    <!--div class="footer-copyright"-->
    <div class="container-fluid copyright">
      © {{year}} <a href="http://www.booknatura.com"> booknatura.com </a>

    </div>
    <!--/div-->
    <!--/.Copyright-->

  </footer>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Footer',
  computed: {
    ...mapState({
      language: state => state.language,
      apiPublicUrl: state => state.app.apiPublicUrl,
    }),
    year() {
      return new Date().getFullYear();
    },
  },
};

</script>

<style lang="scss" scoped>
.container-fluid {
  margin-left: 3%;
  margin-right: 3%;
}
ul {
  margin-bottom: 0;
}

address p {
  line-height: 1;
}

footer {
  margin-top: -60px;
  position: relative;
  width: 100%;
  text-align:center;
  font-size: 12px;
  padding-bottom: 15px;
  background-color: rgba(0,105,92, 0.8);
}

a:hover {
  text-decoration: underline !important;
}
.footerLinks {
  li:first-child:before {
    content: "";
  }
  li:before {
    content: " | "
  }
  li {
    display: inline-block;
  }
}
.logos {
  margin-top: 15px;
  a {
    display: inline-block;
    padding-left: 6px;
    padding-right: 6px;
  }
}
.copyright {
  padding-bottom: 15px;
}
.logoCol {
  img {
    max-width: 400px;
  }
}

.logoCol {
  text-align: center;
  img {
    max-width: 400px;
  }
}

</style>



// WEBPACK FOOTER //
// FooterBlock.vue?22f252d0